import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Layout {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');
		this.$hiddenHeader = $('.js-top-target');

		this.$nav = $('.nav-wrapper');
		this.$primaryNavItem = $('.primary-nav > li');
		this.$primaryNavItemLink = $('.primary-nav > li > a');
		this.$navToggle = $('.js-nav-toggle');
		this.$navToggleLabel = $('.js-nav-toggle-label');
		this.$navToggleChildren = $('.js-nav-toggle-children');

		this.$search = $('.js-search');
		this.$searchToggle = $('.js-search-toggle');
		this.$searchForm = $('.js-search-form');

		this.didScroll = false;
		this.lastScrollTop = 0;
		this.delta = 5;

		this.$footerAccordionItem = $('.js-footer-accordion > .footer-column-navigation-item--parent > a');

		this.timer = 0;

		this.$menuButton = $('.js-menu-icon');
		this.$menuIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 20" fill="none"><g clip-path="url(#clip0_269_1583)"><path fill="currentColor" d="M1.2771 1.07471H24.7231" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path fill="currentColor" d="M1.2771 10.0054H24.7231" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path fill="currentColor" d="M1.2771 18.9253H24.7231" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_269_1583"><rect width="26" height="20" fill="white"/></clipPath></defs></svg>';
		this.$closeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_269_1587)"><path fill="currentColor" d="M1.18115 1.18109L22.8189 22.8189" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path fill="currentColor" d="M22.8189 1.18109L1.18115 22.8189" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>';
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.$navToggle.on('click', (e) => {
			e.stopPropagation();
			this.toggleNav(e);
		});

		this.$navToggleChildren.on('click', (e) => {
			e.stopPropagation();
			this.mobileNavItem(e);
		});

		$('body').on('click', (e) => {
			this.closeSearch(e);
		});

		// on menu enter
		this.$primaryNavItemLink.on('keydown', (e) => {
			this.tabbingNav(e);
		});
		
		this.$primaryNavItemLink.on('click', (e) => {
			if (Util.getViewPort() !== CONST.ViewPort.Desktop && $(e.currentTarget).hasClass('js-nav-toggle-children')) {
				e.preventDefault();
				this.$search.addClass('fix-top');
			}
		});

		// open megamenu on hover for desktop
		this.$primaryNavItem
			.on('mouseover', (e) => {
				clearTimeout(this.timer);
				$('.js-nav-megamenu').removeClass('open');
				this.openSubmenu(e);
			})
			.on('mouseleave', (e) => {
				this.timer = setTimeout(() => {
					this.closeSearch(e);
					this.closeSubmenu(e);
				}, 300);
			});

		// Hide Header on on scroll down
		$(window).scroll(() => {
			this.didScroll = true;
		});

		setInterval(() => {
			if (this.didScroll) {
				this.hasScrolled();
				this.didScroll = false;
			}
		}, 100);

		// Search toggle
		this.$searchToggle.on('click', (e) => {
			e.stopPropagation();
			this.toggleSearch(e);
		});

		this.$searchToggle.on('keyup', (e) => {
			if (e.keyCode === 13) {
				this.toggleSearch(e);
			}
		});

		this.$search.on('focusout', (e) => {
			this.closeSearch(e);
		});

		this.handleHeaderOnWindowResize();

		// Footer
		this.handleFooter();

		//Scrolls back to the top after tabbing through page
		this.$hiddenHeader.focus(() => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		});

		$('.megamenu-nav-slider-trigger').on('click', (e) => {
			e.preventDefault();
			const target = $(e.currentTarget);
			const boxId = target.data('link-id');

			$('.megamenu-nav-slider-block').removeClass('active');
			
			this.$search.addClass('fix-top');

			const $block = $(`.megamenu-nav-slider-block[data-box-id="${boxId}"]`);
			$block.addClass('active');

			target.closest('.nav-megamenu').css('height', `${$block.outerHeight()}px`);
		});

		$('.megamenu-nav-slider-close').on('click', (e) => {
			e.preventDefault();

			$('.megamenu-nav-slider-block').removeClass('active');
			$(e.currentTarget).closest('.nav-megamenu').css('height', 'inherit');
		});

		$('.primary-nav.mobi-box .is-parent-box').on('click', (e) => {
			e.preventDefault();
			const key = $(e.currentTarget).attr('key');
			$('.nav-megamenu-mobile').removeClass('active');
			$(`.nav-megamenu-mobile[data-id-box="${key}"]`).addClass('active');
		});

		$('.megamenu-nav-mobile-close').on('click', (e) => {
			e.preventDefault();
			this.$search.removeClass('fix-top');
			$('.nav-megamenu-mobile').removeClass('active');
			$('.megamenu-nav-slider-block').removeClass('active');
		});

		//---/ Footer
	}

	handleFooter() {
		if ($(window).width() <= 568) {
			this.mobileFooter();
		} else {
			this.desktopFooter();
		}
		$(window).resize(() => {
			this.desktopFooter();
			if ($(window).width() <= 568) {
				this.mobileFooter();
			}
		});
	}

	handleHeaderOnWindowResize() {
		$(window).resize(() => {
			if ($(window).width() > 998) {
				this.$body.css('padding-top', 0);
				this.$header.css('top', 'auto');
				this.$body.removeClass('header-up').removeClass('header-down');
				$('.js-nav-megamenu').css('display', '');
				$('body').removeClass('nav-open');
			}
		});
	}

	hasScrolled() {
		if ($(window).width() >= 998) return;
		const st = $(window).scrollTop();
		const headerHeight = $('.header').outerHeight();
		const progressHeight = $('#readingProgressBar').hasClass('closed') || $('#readingProgressBar').length === 0 ? 0 : $('#readingProgressBar').outerHeight();
		const bannerHeight = $('.js-banner').hasClass('closed') || $('.js-banner') === undefined || $('.js-banner').length === 0 ? 0 : $('.js-banner').outerHeight();

		// Make sure they scroll more than delta
		if (Math.abs(this.lastScrollTop - st) <= this.delta) {
			return;
		}

		// If they scrolled down and are past the header, add class .header-up.
		// This is necessary so you never see what is "behind" the header.
		if (st > headerHeight) {
			this.$body.css('padding-top', headerHeight);

			if (st > this.lastScrollTop) {
				// Scroll Down
				this.$body.removeClass('header-down').addClass('header-up');
				this.$header.css('top', -headerHeight);
			} else if (st + $(window).height() < $(document).height()) {
				// Scroll Up
				this.$body.removeClass('header-up').addClass('header-down');
				this.$header.css('top', progressHeight - bannerHeight);
			}
		} else if (st <= bannerHeight + 50) {
			this.$body.css('padding-top', 0);
			this.$header.css('top', 'auto');
			this.$body.removeClass('header-up').removeClass('header-down');
		}

		this.lastScrollTop = st;
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			const target = $(e.currentTarget);
			const parent = target.closest('li');
			const menuContainer = $(parent).find('.nav-megamenu-container');
			const menuList = $(parent).find('> .primary-nav-submenu--nested');

			$(parent).toggleClass('open');
			this.$search.addClass('fix-top');

			if (menuList.length > 0) {
				$(menuList).slideToggle();
			} else {
				$(menuContainer).slideToggle();
			}
			e.preventDefault();
		}
	}

	openSubmenu(e) {
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			const target = $(e.currentTarget);
			$('.primary-nav li').removeClass('open');
			$(target).closest('li').addClass('open');
			$(target).closest('li').find('.js-nav-megamenu').addClass('open');
		}
	}

	closeSubmenu(e) {
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			const target = $(e.currentTarget);
			$('.primary-nav li').removeClass('open');
			$(target).closest('li').find('.js-nav-megamenu').removeClass('open');
			this.$search.removeClass('fix-top');

			$('.megamenu-nav-slider-block').removeClass('active');
			$('.nav-megamenu').css('height', 'inherit');
		}
	}

	// if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
	tabbingNav(e) {
		const target = $(e.currentTarget);
		
		if (e.keyCode === 13 && target.hasClass('has-dropdown')) {
			e.preventDefault();
			target.closest('li').addClass('focused');
			target.closest('li').find('.js-nav-megamenu').addClass('open');
		}

		const $activeElem = $(document.activeElement);
		const $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
			$prevItem.find('.js-nav-megamenu').removeClass('open');
		}

		if (e.shiftKey && e.keyCode === 9) {
			$('.js-nav-megamenu').removeClass('open');
		}
	}

	// toggle nav on mobile
	toggleNav(e) {
		$('.js-nav-megamenu').removeAttr('style').closest('li').removeClass('open'); // Open nav with sub menus closed
		$('.nav-megamenu-mobile, .megamenu-nav-slider-block').removeClass('active');

		const target = $(e.currentTarget);
		target.toggleClass('open');

		this.$nav.slideToggle().toggleClass('open');
		this.$body.toggleClass('nav-open');
		this.$search.removeClass('fix-top');

		if (this.$body.hasClass('nav-open')) {
			this.$menuButton.html(this.$closeIcon);
			this.$navToggleLabel.text('Close');
		} else {
			this.$menuButton.html(this.$menuIcon);
			this.$navToggleLabel.text('Menu');
		}
	}

	// Footer accordion expand/collapse
	footerAccordion(e) {
		const target = $(e.currentTarget);

		target.parent().toggleClass('open');
		target.siblings('.footer-column-navigation-sub').toggleClass('visible');
	}

	toggleSearch(e) {
		$('.js-search-textbox').focus();

		this.$searchToggle.addClass('hide');

		setTimeout(() => {
			this.$search.addClass('open');
			this.$searchForm.addClass('open');
		}, 150);
	}

	// Close search
	closeSearch(e) {
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			const target = $(e.target);

			if (target.hasClass('js-search-toggle')) return;
			if ((target.hasClass('js-search-textbox') === false && target.hasClass('js-search-btn') === false && target.hasClass('fa-search') === false) || e.type === 'focusout' || e.type === 'mouseout') {
				this.$search.removeClass('open');
				this.$searchForm.removeClass('open');

				setTimeout(() => {
					this.$searchToggle.removeClass('hide');
				}, 260);
			}
		}
	} //---/ Close search

	// Mobile footer
	mobileFooter() {
		// Move social icons to top
		$('.footer-column-social').prependTo($('.footer-column').first());
	} //---/ Mobile footer

	// Desktop footer
	desktopFooter() {
		// Move social icons to last column
		$('.footer-column-social').prependTo($('.footer-column:nth-child(4)'));
	} //---/ Desktop footer
}

export default Layout;
